import React, { useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";

import { useToast } from "../../core/contexts/toast";

import FiltroPI from "./filtro";
import { useAutenticação } from "../../core/contexts/auth";
import { atualizaTamanhoTabela } from "../../core/utils/funcoes";
import { sazonalidadeContexto } from "../../core/contexts/sazonalidadeContexto";
import { useTranslation } from "react-i18next";
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, ArcElement } from 'chart.js';
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, ArcElement);
import { FiltroPlantaIndustrial } from "../../core/repositories/plantaIndustrialRepositorio";
import { plantaIndustrialContext } from "../../core/contexts/plantaIndustrialContexto";
import SopPrincipalKPICards from "./SopPrincipalKPICards";
import SopPrincipalSalesCard from "./SopPrincipalSalesCard";
import SopPrincipalTrendLineChart from "./SopPrincipalTrendLineChart";
import SopProductionFollowerProgressCard from "../SopProduction/SopProductionFollowerProgressCard";
import SopProductionGrowthChart from "../SopProduction/SopProductionGrowthChart";
import SopProductionRevenueStackedBarChart from "../SopProduction/SopProductionRevenueStackedBarChart";
import SopProductionScheduleAdherence from "../SopProduction/SopProductionScheduleAdherence";
import SopProductionCapacityBar from "./SopProductionCapacityBar";
import SopProductionRegionPieChart from "./SopProductionRegionPieChart";
import { SopSalesSalesForecastChart } from "./SopSalesSalesForecastChart";
import SopSalesRegionPieChart from "../SopSales/SopSalesRegionPieChart";
import SopSalesRevenueStackedBarChart from "../SopSales/SopSalesRevenueStackedBarChart";
import SopSalesSalesForecastChart2 from "../SopSales/SopSalesKpiChart";
import SopSalesSalesForecastChart3 from "./SopSalesSalesForecastChart3";
import { FiltroSopSales } from "../../core/repositories/sopSalesRepositorio";

var contador: number = 0;

export default function SopElementos() {
  const { t } = useTranslation();
  const bodyRef = useRef(null);
  const { carregarLista, atualizarInterface, atualizarFiltroContexto, filtroNoContexto, setCarregando } = sazonalidadeContexto();
  const { mostrarToast } = useToast();
  const { usuario } = useAutenticação()
  const [filtro, setFiltro] = useState(new FiltroSopSales());
  const [permissaoEditar, setPermissaoEditar] = useState<boolean>(false)
  const planta = plantaIndustrialContext();

  React.useEffect(() => {
    carregarDados(filtro)
    var novoFiltro = new FiltroPlantaIndustrial()
    setCarregando(true)
    novoFiltro.cod_usuario = usuario?.cod_usuario
    novoFiltro.flg_carregar_painel = true
    novoFiltro.flg_aberto = false
    planta.atualizarFiltroContexto({ ...novoFiltro })
    planta.carregarLista(novoFiltro).then(() => {
      planta.atualizarInterface();
    });

  }, []);

  React.useEffect(() => {
    // Seu código a ser executado quando a altura da página mudar para atualizar o tamanho da tabela
    const observer = new MutationObserver(atualizaTamanhoTabela);
    if (bodyRef.current) {
      observer.observe(bodyRef.current, { attributes: true, childList: true, subtree: true });
    }
    return () => {
      observer.disconnect();
    };
  });


  async function carregarDados(filtro: FiltroSopSales) {
    try {
      const _contador = contador++;
      if (_contador === contador - 1) {
        await carregarLista(filtro);
        atualizarInterface();
      }
    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }

  function atualizarFiltro(novoFiltro: FiltroSopSales) {
    setFiltro({ ...novoFiltro });
  }

  async function filtrarDados(novoFiltro: FiltroSopSales) {
    setCarregando(true)
    novoFiltro.flg_aberto = false
    setFiltro({ ...novoFiltro });
    atualizarFiltroContexto({ ...novoFiltro })
    carregarDados(novoFiltro);
  }

  function limparFiltro() {
    const _filtro = new FiltroSopSales();
    _filtro.flg_aberto = filtro.flg_aberto;
    atualizarFiltro(_filtro)
  }
  // <SopPrincipalTrendLineChart />
  const elementos = [
    {
      item: <SopPrincipalKPICards />,
      nome: "SopPrincipalKPICards",
    },
    // {
    //   item: <SopPrincipalSalesCard />,
    //   nome: "SopPrincipalSalesCard",
    // },
    // {
    //   item: <SopPrincipalTrendLineChart data={[52, 36, 90, 85, 74, 59, 63, 145, 54]} />,
    //   nome: "SopPrincipalTrendLineChart",
    // },
    // {
    //   item: <SopProductionFollowerProgressCard maxLabel="100" title="Capacity Utilization" percent={65} subtitle="Percentage of available capacity used monthly" />
    //   ,
    //   nome: "SopProductionFollowerProgressCard",
    // },
    // {
    //   item: <SopProductionGrowthChart filtro={filtro} />,
    //   nome: "SopProductionGrowthChart",
    // },
    // {
    //   item: <SopProductionScheduleAdherence />,
    //   nome: "SopProductionScheduleAdherence",
    // },
    // {
    //   item: <SopProductionRevenueStackedBarChart filtro={filtro} />,
    //   nome: "SopProductionRevenueStackedBarChart",
    // },
    // {
    //   item: <SopProductionRegionPieChart />,
    //   nome: "SopProductionRegionPieChart",
    // },
    // {
    //   item: <SopProductionCapacityBar labelBefore="Capacity Utilization by" labelAfter="Available" percent={72} />,
    //   nome: "SopProductionCapacityBar",
    // },
    // {
    //   item: <SopSalesSalesForecastChart filtro={filtro} />,
    //   nome: "SopSalesSalesForecastChart",
    // },
    // {
    //   item: <SopSalesSalesForecastChart2 filtro={filtro} />,
    //   nome: "SopSalesSalesForecastChart2",
    // },
    // {
    //   item: <SopSalesRevenueStackedBarChart filtro={filtro}/>,
    //   nome: "SopSalesRevenueStackedBarChart",
    // },
    // {
    //   item: <SopSalesRegionPieChart filtro={filtro} />,
    //   nome: "SopSalesRegionPieChart",
    // },
    // {
    //   item: <SopSalesSalesForecastChart3 />,
    //   nome: "SopSalesSalesForecastChart3",
    // },
    {
      item: <div />,
      nome: "div",
    },
    {
      item: <div />,
      nome: "div",
    },
    {
      item: <div />,
      nome: "div",
    },
    {
      item: <div />,
      nome: "div",
    },
    {
      item: <div />,
      nome: "div",
    },

  ]

  return (
    <div className="sazonalidade " ref={bodyRef}>
      <div className="px-2">

        <FiltroPI
          titulo={t("Elementos")}
          filtro={filtro}
          atualizarFiltro={atualizarFiltro}
          permissaoEditar={permissaoEditar}
          filtrarDados={filtrarDados}
        />
      </div>




      <div className="table-100" >
        <div id="tabela">
          <div className="table-responsive">

            <div className="tabs-container card px-2  shadow-sm border-0">

              <div>
                <Row className="">
                  {elementos.map((elemento, index) => (
                    <Col key={index} md={6} className="mb-3">
                      <Card>
                        {elemento.item}
                      </Card>
                    </Col>
                  ))}

                </Row>


              </div>
            </div>




          </div>

        </div>
      </div>


    </div>
  );
}
